import React from "react";
import { Avatar, Box, Typography } from "@material-ui/core";
import moment from "moment";
import { DefaultAvatar } from "./../../../constants/medias";

const ModifiedByInfo = ({
  resources,
  modifiedByAvatar,
  modifiedOn,
  modifiedByName,
  isCreated,
  localeDate = false,
  className = "mb-3",
}) => {
  const formattedDate = !localeDate
    ? moment(modifiedOn).format("DD/MM/YYYY HH:mm")
    : moment.utc(modifiedOn).local().format("DD/MM/YYYY HH:mm");

  return (
    <Box
      id="user-modified-info-container"
      display="flex"
      alignItems="center"
      className={className}
      justifyContent="center"
    >
      <Avatar
        id="user-modified-avatar"
        alt="user-avatar"
        src={modifiedByAvatar || DefaultAvatar}
        style={{
          marginRight: "8px",
          width: "35px",
          height: "35px",
        }}
      />
      <Typography variant="body2" id="user-modified-text">
        {`${
          isCreated ? resources["CreatedOn"] : resources["ModifiedOn"]
        } ${formattedDate} ${
          modifiedByName ? `${resources["By"]} ${modifiedByName}` : ""
        }`}
      </Typography>
    </Box>
  );
};

export default ModifiedByInfo;
